import {
    SET_RESET,
    SET_ERROR,
    SET_LOADING, SET_BANNERS,


} from "./mutation_types";
import {
    GET_BANNERS,

    GET_RESET,


} from "./action_types";
import {getApi} from "../../data/ApiService";

export default {
    async [GET_BANNERS]({commit},payload){
        commit(SET_LOADING,true);
        try{
            const response = await getApi('banners/4');
            console.log(response);
            commit(SET_BANNERS,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },

    async [GET_RESET]({commit}) {


        commit(SET_RESET);

    },
};
